module.exports = __webpack_public_path__ + "static/icon-cuncurrent-a240105a28ff4ea89f76eb43040dd59b.png";